import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const LoginToggle = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAdmin = location.pathname === '/admin';

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
            p: 0.5,
            backgroundColor: '#f0f2f5',
            borderRadius: 4,
            width: 'fit-content',
            mx: 'auto'
        }}>
            <Button
                onClick={() => navigate('/login')}
                sx={{
                    borderRadius: 3,
                    px: 4,
                    py: 1,
                    backgroundColor: !isAdmin ? '#fff' : 'transparent',
                    color: !isAdmin ? '#218838' : '#6c757d',
                    boxShadow: !isAdmin ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
                    '&:hover': {
                        backgroundColor: !isAdmin ? '#fff' : '#e9ecef',
                    },
                    textTransform: 'none',
                    fontWeight: !isAdmin ? 'bold' : 'normal',
                    display: 'flex',
                    gap: 1
                }}
            >
                <PersonIcon fontSize="small" />
                Employee
            </Button>
            <Button
                onClick={() => navigate('/admin')}
                sx={{
                    borderRadius: 3,
                    px: 4,
                    py: 1,
                    backgroundColor: isAdmin ? '#fff' : 'transparent',
                    color: isAdmin ? '#218838' : '#6c757d',
                    boxShadow: isAdmin ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
                    '&:hover': {
                        backgroundColor: isAdmin ? '#fff' : '#e9ecef',
                    },
                    textTransform: 'none',
                    fontWeight: isAdmin ? 'bold' : 'normal',
                    display: 'flex',
                    gap: 1
                }}
            >
                <AdminPanelSettingsIcon fontSize="small" />
                Admin
            </Button>
        </Box>
    );
};

export default LoginToggle;
